import {
  Component,
  ChangeDetectionStrategy,
  OnInit,
  inject,
  PLATFORM_ID,
  ChangeDetectorRef,
} from "@angular/core";
import {
  FormArray,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";

import { CommonModule, DatePipe, isPlatformServer } from "@angular/common";

import {
  TuiAlertService,
  TuiButton,
  TuiIcon,
  TuiLabel,
  TuiLink,
  TuiTitle,
} from "@taiga-ui/core";
import {
  TuiProgressBar,
  TuiFieldErrorPipe,
  TuiCheckbox,
  TuiFilterByInputPipe,
  TuiFiles,
} from "@taiga-ui/kit";

import {
  TuiError,
  TuiDataList,
  TuiAppearance,
  TuiRoot,
  TuiTextfield,
  TuiDropdown,
} from "@taiga-ui/core";
import {
  TuiDataListWrapper,
  TuiRadio,
  TuiAvatar,
  TuiBadge,
  TuiItemsWithMore,
  TuiProgress,
  TuiBadgedContent,
  TuiTabs,
  TuiInputNumber,
} from "@taiga-ui/kit";

import {
  TuiInputDateModule,
  TuiInputModule,
  TuiInputPhoneModule,
  TuiInputSliderModule,
  TuiInputTimeModule,
  TuiSelectModule,
  TuiTextfieldControllerModule,
  TuiTextareaModule,
  TuiInputTagModule,
  TuiComboBoxModule,
  TuiMultiSelectModule,
  TuiInputDateTimeModule,
  TuiInputNumberModule,
} from "@taiga-ui/legacy";

import { TUI_IS_E2E, TuiDay } from "@taiga-ui/cdk";
import { AsyncPipe } from "@angular/common";
import { of, timer, takeWhile, share, repeat, map, timeout, catchError, throwError } from "rxjs";
import { NG_EVENT_PLUGINS } from "@taiga-ui/event-plugins";
import { Router } from "@angular/router";
import { Meta, Title } from "@angular/platform-browser";
import { NgxSpinnerService } from "ngx-spinner";
import { environment } from "../../../../environments/environment";
import { AuthService } from "../../../services/auth.service";
import { ProgramService } from "../../../services/program.service";
import { ClowderService } from "../../../services/clowder.service";
import { ClowderConfig, ClowderfrontUrl } from '../../../storan-constant';
import { SharedService } from "../../../services/shared.service";

@Component({
  selector: 'app-satisfaction-survey',
  standalone: true,
  imports: [ReactiveFormsModule,
    CommonModule,
    AsyncPipe,
    TuiProgressBar,
    TuiButton,
    TuiDropdown,
    TuiLabel,
    TuiFieldErrorPipe,
    TuiError,
    TuiDataList,
    TuiAppearance,
    TuiRadio,
    TuiInputDateModule,
    TuiTextfield,
    TuiTextfieldControllerModule,
    TuiInputModule,
    TuiInputNumber,
    TuiInputPhoneModule,
    TuiInputTimeModule,
    TuiSelectModule,
    TuiTextareaModule,
    TuiCheckbox,
    TuiAvatar,
    TuiInputTagModule,
    TuiIcon,
    TuiProgress,
    TuiFilterByInputPipe,
    TuiFiles,
    TuiComboBoxModule,
    TuiMultiSelectModule,
    TuiBadgedContent,
    TuiDataListWrapper,
    TuiInputNumberModule,
    TuiInputSliderModule,
    TuiTextfieldControllerModule,
    TuiItemsWithMore,
    TuiTabs,
    FormsModule,
    TuiTitle,
    TuiInputDateTimeModule,
    TuiLink,
    TuiRoot],
  templateUrl: './satisfaction-survey.component.html',
  styleUrl: './satisfaction-survey.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [NG_EVENT_PLUGINS, DatePipe],
})
export class SatisfactionSurveyComponent {
  dataSetId: any;
  emailAddress: any;
  growerid: any;
  trialId: any;
  growerDetails: any;
  uploadImageId: any;
  noImageAssets: any;
  satisfactionSurveyStatus: any;
  cleanRowPhotosStatus: any;
  programSchedule: any;
  constructor(private router: Router, private meta: Meta, private title: Title, private spinner: NgxSpinnerService, private authService: AuthService, private sharedService: SharedService,
    private programService: ProgramService, private cdr: ChangeDetectorRef, private _clowderService: ClowderService, private datepipe: DatePipe) {
    this.title.setTitle("Take the Satisfaction Survey");
    this.meta.updateTag({ name: 'description', content: '' })
  }
  currentSurveyStep: number = 3;
  currentSurveyInnerStep: number = 1;
  currentSatisfactionStep: number = 1;
  currentStep: number = 3;
  firstPage: number = 2;
  experienceLength: number = 0;
  improveStorenLength: number = 0;
  private readonly alerts = inject(TuiAlertService);
  ngAfterViewInit() {
    setTimeout(() => {
      // document.querySelector('#satisifactionSurvey')?.scrollIntoView({ behavior: 'smooth', block: 'center' });

      document.getElementById("satisifactionSurvey")?.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      });
    }, 600);
  }
  ngOnInit(): void {
    this.authService.checkAuthAndRedirect();
    this.emailAddress = localStorage.getItem("email");
    this.getGrowerDetails();
    this.cdr.detectChanges();
    this.getProgramSchedule();
    let dataSets = JSON.stringify(environment.ClowderConfig.datasets.find(item => Object.keys(item).includes('Corn-field')));
    this.dataSetId = JSON.parse(dataSets)['Corn-field'];
    //this.dataSetId = '67781d76a33165e4f81d1bab';
    this.satisfactionSurveyStatus = sessionStorage.getItem("satisfactionSurveyStatus") ? sessionStorage.getItem("satisfactionSurveyStatus") : "";
    if (this.satisfactionSurveyStatus === 'COMPLETED' || this.satisfactionSurveyStatus === 'LOCK' || this.satisfactionSurveyStatus == 'GETSTARTEDDISABLE' || !this.satisfactionSurveyStatus) {
      this.router.navigate(['/program']);
    }

    this.satisfactionSurveyForm.get('experienceWithStoren')?.valueChanges.subscribe((value) => {
      this.experienceLength = value?.length ?? 0;
    });
    this.satisfactionSurveyForm.get('improveStorenCorn')?.valueChanges.subscribe((value) => {
      this.improveStorenLength = value?.length ?? 0;
    })

  }

  convertToTuiDay(date: string | Date): TuiDay {
    const jsDate = new Date(date);
    return new TuiDay(jsDate.getFullYear(), jsDate.getMonth(), jsDate.getDate());
  }
  getGrowerDetails() {
    this.programService.getgrowerdetailsbyEmailId(this.emailAddress).subscribe((res: any) => {
      this.growerDetails = JSON.parse(res);
      if (this.growerDetails.length > 0) {
        this.growerid = this.growerDetails[0].GROWER_ID;
        this.trialId = this.growerDetails[0].trail_id == null ? this.generateTrialId(this.growerDetails[0]) : this.growerDetails[0].trail_id;
      }
    })
  }
  generateTrialId(growerDetails: any) {
    const CU = growerDetails['CU_Description'];
    const growerLastName = growerDetails['USER_LAST_NAME'];
    const randomSixDigitNumber = Math.floor(100000 + Math.random() * 900000);
    const year = new Date().getFullYear();
    return `${CU}_${growerLastName}_${randomSixDigitNumber}_${year}`;
  };
  protected satisfactionSurveyForm = new FormGroup({
    applyDate: new FormControl(new TuiDay(2017, 2, 15)),
    satisfactionScaleForStorenCornHerbicide: new FormControl(
      "",
      Validators.required
    ),
    experienceWithStoren: new FormControl("", [Validators.required, Validators.maxLength(1000)]),
    improveStorenCorn: new FormControl("", [Validators.required, Validators.maxLength(1000)]),
    selectedRatingOption: new FormControl("", Validators.required),
    selectedRewardOption: new FormControl("", Validators.required),
  });


  returnDashboard() {
    this.currentSurveyStep = 1;
    this.currentStep = 1;
    this.firstPage = 1;
    this.router.navigate(['/program']).then(()=>{
      window.scrollTo({top:0,behavior:'smooth'});
    })
  }

  async submitSatisfactorySurvey() {
    this.currentSatisfactionStep = 2;
    this.firstPage = 0;
    this.spinner.show();
    //this.currentSurveyInnerStep = 2;
    this.firstPage = 0;

    if (this.satisfactionSurveyForm.valid) {
      if (this.growerDetails[0].trail_id == null || this.growerDetails[0].trail_id == "") {
        const trialdetails =
        {
          "TrialId": this.trialId,
          "TrialType": "SSP",
          "GrowerId": this.growerid,
          "Crop": "Corn (field)",
          "NoOfTreatments": 1,
          "treatments": [""],
          "TreatmentName": [""],
          "NoOfReplication": 1,
          "GeoLatitude": "0.000000",
          "GeoLongitude": "0.000000",
          "AddressLine1": this.growerDetails ? this.growerDetails[0]['USER_ADDRESS1'] : "",
          "AddressLine2": this.growerDetails ? this.growerDetails[0]['USER_ADDRESS2'] : "",
          "City": this.growerDetails ? this.growerDetails[0]['USER_CITY'] : "",
          "State": this.growerDetails ? this.growerDetails[0]['USER_STATE'] : "",
          "ZipCode": this.growerDetails ? this.growerDetails[0]['USER_POSTAL_CODE'] : "",
          "TrialTreatments": "",
          "FieldDescription": "",
          "UpdatedBy": this.emailAddress,
          "TreatmentName1": ""
        };
        await this.programService.trialRegistration(trialdetails).subscribe((response) => {
          if (response > 0) {
          } else {
            this.spinner.hide();
            this.alerts.open('<strong>Something went wrong</strong>', { label: 'Error!', appearance: 'negative', autoClose: 1000 }).subscribe();
          }
        });
      }

      await this.uploadDefaultNoImage();
    //   let saveApplCheckInObj = {
    //     "GrowerId": this.growerid,
    //     "TrailId": this.trialId,
    //     "ProgramScheduleId": 2,
    //     "Programstatus": "Completed"
    //   }
    //   this.programService.insertprogramdetails(saveApplCheckInObj).subscribe(async () => {
    //     await this.uploadDefaultNoImage();
    //     // this.currentSurveyInnerStep = 2;
    //     // this.spinner.hide();
    //   }, (error) => {
    //     this.spinner.hide();
    //     console.error('Error saving API :', error);
    //   });
     }
  }
  private async uploadDefaultNoImage(): Promise<void> {
    try {
      this.spinner.show();
      // const id = crypto.randomUUID();
      // Create and upload new no-image asset
      const response1 = await fetch('No-image.png');
      const blob = await response1.blob();
      const uniquenumber = Date.now();
      //  const fileName = `No-Image_${uuidv4().substr(0, 6)}.png`;
      const fileName = `No-Image_${uniquenumber}.png`;
      const file = new File([blob], fileName, { type: blob.type });

      const formDatas = new FormData();
      formDatas.append('type', 'file');
      formDatas.append('path', `/${fileName}`);
      formDatas.append('file', file, fileName);
      this.noImageAssets = ClowderfrontUrl + 'Corn-field/' + fileName;

      new Promise((resolve, reject) => {
        this._clowderService.uploadImage(formDatas, this.dataSetId)
          .pipe(
            timeout(90000),
            catchError(error => {
              this.handleError(error, 'Error uploading no-image asset');
              this.errorCaptureDB(error,"Error Uploading no-image asset");
              reject(error);
              return throwError(() => error);
            })
          )
          .subscribe({
            next: (res) => {
              if (res['id'] !== '') {
                this.uploadImageId = res['id'];
                resolve(this.uploadImageMetadata(res['id']));
              }
            },
            error: (error) => reject(error)
          });
      });
      //this.current_step = 2;
      this.cdr.detectChanges();

    } catch (error) {
      console.error('Error uploading no-image asset:', error);
      throw error;
    }
  }

  characValidation(value: any): boolean {
    if (value.length >= 1000) {
      return false;
    }
    return true;
  }

  convertToDate(tuiDay: TuiDay): string {
    if (tuiDay === null || tuiDay === undefined) {
      return '';
    }
    const date = new Date(tuiDay.year, tuiDay.month, tuiDay.day);
    return date.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
  }
  async uploadImageMetadata(fileId: any) {
    this.spinner.show();
    const SubmittedOn = this.datepipe.transform(new Date(), 'MM/dd/yyyy HH:mm:ss')
    // const SubmittedOn = new Date().toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
    let noImageFilename = this.noImageAssets.split('/')[4];
    let saveSatisfactionSurveyObject = {
      "MS-Trial Type": "SSP",
      "MS-Trial ID": this.trialId,
      "MS-Asset-url": this.noImageAssets,
      "MS-SubmittedOn": SubmittedOn,
      "MS-Asset File Name": noImageFilename,
      "MS-CU Role": this.growerDetails[0]['CU_Description'],
      "MS-Crop": "Corn (field)",
      "MS-Product Type": "Herbicide",
      "MS-Product": "Storen",
      "MS-Asset Type": "No-Image",
      "MS-Submitter Email": this.emailAddress,
      "MS-Program Status": "Satisfaction Survey",
      "MS-Satisfaction Survey": {
        "MS-Satisfied": this.satisfactionSurveyForm.value.satisfactionScaleForStorenCornHerbicide,
        "MS-Experience": this.satisfactionSurveyForm.value.experienceWithStoren,
        "MS-Feedback": this.satisfactionSurveyForm.value.improveStorenCorn,
        "MS-Rate": this.satisfactionSurveyForm.value.selectedRatingOption,
        "MS-Reward": this.satisfactionSurveyForm.value.selectedRewardOption,
      },

      "MS-SU Approval Status": "Pending",
      "MS-SU Approved or Rejected Date": "",
      "MS-SU Approved or Rejected by": "",
      "MS-SU Comments": "",
      "MS-Legal Approval Status": "Pending",
      "MS-Legal Approved or Rejected Date": "",
      "MS-Legal Comments": "",
      "MS-Legal Approved or Rejected by": ""

    }

    return this._clowderService.uploadImageMetadata(fileId, saveSatisfactionSurveyObject, this.emailAddress)
      .pipe(
        catchError(error => {
          this.handleError(error, `Error uploading metadata for ${this.noImageAssets}`);
          this.errorCaptureDB(error,`Error uploading metadata for ${this.noImageAssets}`);
          // this.spinnerPercentage = 0;
          // this.spinnerContent = "Loading";
          this.spinner.hide();
          return throwError(() => error);
        })
      )
      .subscribe({
        next: (res) => {
          this.updateStatusDB();
          setTimeout(() => {
            document.querySelector('#satisiFacThanks')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }, 600)
          this.currentSatisfactionStep = 2;
          sessionStorage.setItem("satisfactionSurveyStatus", "COMPLETED");
          this.spinner.hide();
          if (!res) {
            // this.spinnerPercentage = 0;
            // this.spinnerContent = "Loading";
            // this.currentSurveyInnerStep = 2;
            // this.spinner.hide();
          }
        },
        error: (error) => {
          // this.spinnerPercentage = 0;
          // this.spinnerContent = "Loading";
          this.spinner.hide();
          this.errorCaptureDB(error,`Error uploading metadata for ${this.noImageAssets}`);
          this.handleError(error, `Error uploading metadata for ${this.noImageAssets}`);
        }
      });
  }

  updateStatusDB(){
    let saveApplCheckInObj = {
        "GrowerId": this.growerid,
        "TrailId": this.trialId,
        "ProgramScheduleId": 2,
        "Programstatus": "Completed"
      }
      this.programService.insertprogramdetails(saveApplCheckInObj).subscribe(async () => {
         //this.spinner.hide();
      }, (error) => {
        this.spinner.hide();
        console.error('Error saving API :', error);
      });
  }
  errorCaptureDB(error:any,errorMsgs:any){
    let newVar = this.stripHtmlTags(error.error);
    let textLog = 'GrowerId:'+this.growerid+','+'Email:'+this.emailAddress+','+"Program:Satisifacation-Survey,Message="+error.message+"Error:"+newVar;  
    this.programService.errorDetailsLog(textLog, errorMsgs).subscribe(res => {
    }, (error) => {
      console.error('Error saving dataloop API :', error);
    });

  }
  private stripHtmlTags(html: string): string {
    if (typeof html !== 'string') return '';
    return html.replace(/<[^>]*>/g, '').replace(/\n/g, ' ').trim();
  }
  private handleError(error: any, customMessage: string = 'An error occurred'): void {
    console.error('API Error:', error);
    this.spinner.hide();
    this.alerts.open(customMessage, {
      label: 'Error!',
      appearance: 'error',
      autoClose: 5000
    }).subscribe();
  }
  getProgramSchedule() {
    let todaysDate = new Date();
    this.spinner.show();
    this.programService.getProgramSchedule().subscribe((schedule: any) => {
      this.programSchedule = schedule;
      if (this.programSchedule != "") {
        this.programSchedule = JSON.parse(this.programSchedule);
        this.programSchedule.forEach((data: any) => {
          if (data.Id == 3) {
            let startDate = new Date(data.Start_Date);
            let endDate = new Date(data.End_Date);
            if (todaysDate < startDate) {
              this.cleanRowPhotosStatus = 'LOCK';
            } else if (todaysDate > endDate) {
              this.cleanRowPhotosStatus = 'GETSTARTEDDISABLE';
            } else if (todaysDate >= startDate && todaysDate <= endDate) {
              this.cleanRowPhotosStatus = 'GETSTARTED';
            }
          }
        })
      }
    })
    this.spinner.hide();
  }
  downloadImage(imageUrl: string, imageName: string) {
    window.open(imageUrl, "_blank");
  }
  charSubstring(value: any, index: any) {
    if (index == 'experienceWithStoren') {
      if (value && value.length > 1000) {
        value = value.substring(0, 1000)
        this.satisfactionSurveyForm.get('experienceWithStoren')?.setValue(value);
      }
    } else if (index == 'improveStorenCorn') {
      if (value && value.length > 1000) {
        value = value.substring(0, 1000)
        this.satisfactionSurveyForm.get('improveStorenCorn')?.setValue(value);
      }
    }
  }
  async continueToPhotoUpload() {
    this.currentSurveyStep = 4;
    this.currentStep = 4;
    sessionStorage.setItem('cleanRowPhotosStatus', this.cleanRowPhotosStatus);
    if (this.cleanRowPhotosStatus == 'GETSTARTED') {
      this.router.navigate(['/clean-row-photos']).then(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      });
    }
    else {
      this.router.navigate(['/program']).then(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      });
    }

  }
}
